import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { HomePage } from '../../home/home';

@IonicPage()
@Component({
  selector: 'page-expense-calculator',
  templateUrl: 'expense-calculator.html',
})
export class ExpenseCalculatorPage {

  constructor(public alertCtrl: AlertController,public navCtrl: NavController, public navParams: NavParams) {
    this.presentConfirm();
  }

  presentConfirm() {
    let alert = this.alertCtrl.create({
      title: 'Aviso',
      message: 'Este ejercicio tiene fines didácticos y está basado en la información proporcionada por el usuario. Esta herramienta es de uso exclusivo del usuario y está protegida por un convenio de confidencialidad que aceptas respetar.',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            this.navCtrl.setRoot(HomePage);
          }
        },
        {
          text: 'Aceptar'
        }
      ]
    });
    alert.present();
  }

  ionViewDidLoad() { }

  goToHome() {
    let alert = this.alertCtrl.create({
      title: '¿Estás seguro de querer salir?',
      message: 'Al salir perderás todos los datos que no hayas guardado en tu análisis de gastos.',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Salir',
          handler: () => {
            this.navCtrl.pop();
          }
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/retirement-tools/expense-calculator/expense-calculator.ts